'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import React, { useState } from 'react';

export const HomeTabs = () => {
  const [activeTab, setActiveTab] = useState('social');
  const router = useRouter();
  const searchParams = useSearchParams();

  const updateSearchParams = (params: {
    tab?: string;
    tag?: string | null;
    search?: string;
  }) => {
    const newParams = new URLSearchParams(searchParams.toString());

    if (params.tab !== undefined) {
      newParams.set('tab', params.tab);
      setActiveTab(params.tab);
    }

    router.replace(`?${newParams.toString()}`);
  };

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    updateSearchParams({ tab: tabId });
  };

  return (
    <nav className="flex gap-5 md:my-7 justify-center">
      <button
        onClick={() => router.push('/')}
        className={`
              flex items-center md:text-lg text-xs font-bold transition-all duration-200 hover:cursor-pointer
              ${
                activeTab === 'social'
                  ? 'border-b-2 text-black border-black'
                  : 'text-gray-dark hover:text-gray-900 hover:bg-gray-50'
              }
          `}
      >
        <span className="px-2 font-grotesk">Social</span>
      </button>
      <button
        onClick={() => router.push('/explore-stories')}
        className={`
              flex items-center md:text-lg text-xs font-bold transition-all duration-200 hover:cursor-pointer 
              ${
                activeTab !== 'social'
                  ? 'border-b-2 text-black border-black'
                  : 'text-gray-dark hover:text-gray-900 hover:bg-gray-50'
              }
          `}
      >
        <span className="px-2 font-grotesk">Stories</span>
      </button>
    </nav>
  );
};
